import {SIDEBAR} from "../../constants";
import {trigger} from "../../../utils/events/trigger";

export const initLabelSidebar = (element) => {
	if (element)
	{
		let shiftOpened = undefined;

		element.addEventListener( `touchstart`, function (startEvt) {
			SIDEBAR.isOpened = true;

			const coords = {
				start: {
					x: startEvt.touches[0].clientX,
					y: startEvt.touches[0].clientY
				},
				move: {},
				end: {},
				onOpen: true
			};

			startEvt.preventDefault();

			const onTouchMove = function (moveEvt)
			{
				coords.onOpen = coords.move.x > moveEvt.touches[0].clientX /*|| coords.move.x === undefined*/;

				coords.move.x = moveEvt.touches[0].clientX;
				coords.end.x = coords.move.x - coords.start.x;

				coords.move.y = moveEvt.touches[0].clientY;
				coords.end.y = coords.move.y - coords.start.y;

				const shift = Math.abs(coords.end.x) > SIDEBAR.NODE.offsetWidth ? SIDEBAR.NODE.offsetWidth * -1 : coords.end.x;

				if (SIDEBAR.INPUT.checked)
				{
					SIDEBAR.NODE.style.transform = `translateX(${Math.abs(shiftOpened * -1 + shift) > SIDEBAR.NODE.offsetWidth ? SIDEBAR.NODE.offsetWidth * -1 : shiftOpened * -1 + shift}px)`;
				} else
				{
					SIDEBAR.NODE.style.transform = `translateX(${shift}px)`;
				}

				SIDEBAR.NODE.style.transition = `none`;
			};

			const onTouchUp = function (upEvt)
			{
				if (coords.onOpen && !SIDEBAR.INPUT.checked)
				{
					shiftOpened = SIDEBAR.NODE.offsetWidth;
					trigger(SIDEBAR.INPUT, `change`, true);
				} else
				{
					trigger(SIDEBAR.INPUT, `change`, false);
				}

				SIDEBAR.NODE.style = ``;

				element.removeEventListener(`touchmove`, onTouchMove);
				element.removeEventListener(`touchend`, onTouchUp);
			};

			element.addEventListener(`touchmove`, onTouchMove, {passive: false});
			element.addEventListener(`touchend`, onTouchUp);
		});
	}
};
